import { Type } from 'class-transformer';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import {
	CurriculumMappingCourseEndorsementModel,
	CurriculumMappingCourseEndorsementModel_ClassTransform_Type,
} from '../../organizations/teachers/curriculum-mapping/courses/curriculum-mapping-course.model';
import {
	CurriculumMappingSectionAssignmentModel,
	CurriculumMappingSectionAssignmentModel_ClassTransform_Type,
} from '../../organizations/teachers/curriculum-mapping/curriculum-mapping-section.model';
import {
	CurriculumSectionMappingReplacementModel,
	CurriculumSectionMappingReplacementModel_ClassTransform_Type,
} from '../curriculum-manager-replacement.model';
import {
	CurriculumCourseDeactivatedModel,
	CurriculumCourseDeactivatedModel_ClassTransform_Type,
	CurriculumUserChangeModel,
	CurriculumUserChangeModel_ClassTransform_Type,
} from './curriculum-course-overview.model';

export class CurriculumSectionOverviewAssociationsModel {
	catalog_count: number;
	teacher_count: number;
	student_count: number;
	is_deletable: boolean;
}

export function CurriculumSectionOverviewAssociationsModel_ClassTransform_Type() {
	return CurriculumSectionOverviewAssociationsModel;
}

export class CurriculumSectionLMSMappingModel {
	lms_id: number;
	lms_title: string;
	lms_section_id: string;
	proctor_password: string;
	no_final: boolean;
	non_credit: boolean;
	registration_type: number;
	alternate_contact_relationship_rtid: number;
	requires_parental_consent: boolean;
	required_pass_percent: number;
	lms_url: null;
	@Type(CurriculumMappingCourseEndorsementModel_ClassTransform_Type)
	required_endorsements: CurriculumMappingCourseEndorsementModel[];
	@Type(CurriculumMappingSectionAssignmentModel_ClassTransform_Type)
	assignments: CurriculumMappingSectionAssignmentModel[];
}

export function CurriculumSectionLMSMappingModel_ClassTransform_Type() {
	return CurriculumSectionLMSMappingModel;
}

export class CurriculumSectionSimpleModel {
	section_id: number;
	section_title: string;
	course_title: string;
	course_id: number;
	version_title: string;
	version_code: string;
	term: number;
	term_type: string;
	term_title: string;
}

export class CurriculumSectionOverviewModel extends CurriculumSectionSimpleModel {
	active: boolean;
	version_id: number;
	course_number: string;
	@Type(CurriculumUserChangeModel_ClassTransform_Type)
	created: CurriculumUserChangeModel;
	@Type(CurriculumUserChangeModel_ClassTransform_Type)
	last_edited: CurriculumUserChangeModel;
	@Type(CurriculumCourseDeactivatedModel_ClassTransform_Type)
	deactivated: CurriculumCourseDeactivatedModel;
	@Type(CurriculumSectionOverviewAssociationsModel_ClassTransform_Type)
	associations: CurriculumSectionOverviewAssociationsModel;
	@Type(CurriculumSectionLMSMappingModel_ClassTransform_Type)
	lms_mapping: CurriculumSectionLMSMappingModel;
	@Type(CurriculumSectionMappingReplacementModel_ClassTransform_Type)
	replacements: CurriculumSectionMappingReplacementModel;
	syllabus_file_url: string;
	total_time_credit_hours: number;
}

export function CurriculumSectionOverviewModel_ClassTransform_Type() {
	return CurriculumSectionOverviewModel;
}

export class CurriculumSectionOverviewResponseModel {
	@Type(CurriculumSectionOverviewModel_ClassTransform_Type)
	results: CurriculumSectionOverviewModel[];
	count: number;
}

export interface CurriculumSectionSearchArgument {
	section_id: PagingSearchFieldArgument;
	section_title: PagingSearchFieldArgument;
	version_code: PagingSearchFieldArgument;
	lms_title: PagingSearchFieldArrayArgument;
	lms_id: PagingSearchFieldArgument;
	lms_section_id: PagingSearchFieldArgument;
	term_title: PagingSearchFieldArrayArgument;
	course_title: PagingSearchFieldArgument;
	teacher_count: PagingSearchFieldArgument;
	catalog_count: PagingSearchFieldArgument;
	student_count: PagingSearchFieldArgument;
	created: PagingSearchFieldArgument;
	last_edited: PagingSearchFieldArgument;
	deactivated: PagingSearchFieldArgument;
	active: { value: boolean };
	course_id?: PagingSearchFieldArgument;
	course_number?: PagingSearchFieldArgument;
	term_type?: PagingSearchFieldArgument;
	term?: PagingSearchFieldArgument;
	total_time_credit_hours?: PagingSearchFieldArgument;
}

export interface CurriculumSectionCreateArgument {
	version_id: number;
	term: number;
	course_section_type_id: number;
}
